import React from 'react';
import { Box, Text, Tooltip } from '@chakra-ui/react';

export const MODEL_LIST_PREVIEW_MAX = 3;

/** Etiquetas de modelos desde productModels o model legacy. */
export function getProductModelLabels(row) {
  const fromLinks = (row.productModels || [])
    .map((pm) => pm.model?.description)
    .filter(Boolean);
  if (fromLinks.length > 0) return fromLinks;
  if (row.model?.description) return [row.model.description];
  return [];
}

/**
 * Muestra hasta N modelos; el resto como "+k". Tooltip con la lista completa.
 */
export default function ModelListCell({
  labels,
  emptyLabel = 'Todos',
  maxVisible = MODEL_LIST_PREVIEW_MAX,
}) {
  if (!labels?.length) {
    return (
      <Text fontSize="sm" fontWeight="normal">
        {emptyLabel}
      </Text>
    );
  }

  const full = labels.join(', ');
  const preview = labels.slice(0, maxVisible);
  const extra = labels.length - maxVisible;
  const shortText =
    extra > 0 ? `${preview.join(', ')} +${extra}` : preview.join(', ');
  const showTooltip = extra > 0;

  const content = (
    <Text
      fontSize="sm"
      fontWeight="normal"
      noOfLines={2}
      overflow="hidden"
      textOverflow="ellipsis"
      title={showTooltip ? undefined : full}
    >
      {shortText}
    </Text>
  );

  if (!showTooltip) {
    return content;
  }

  return (
    <Tooltip label={full} hasArrow placement="top" openDelay={250} maxW="320px">
      <Box as="span" display="inline-block" maxW="100%" cursor="help">
        {content}
      </Box>
    </Tooltip>
  );
}
